export default "__VITE_ASSET__C0o9$mXS__"